/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/journal/2020-07-23.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/journal/2020-07-23.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/2020-07-23.mdx';

const metadata = {
  slug: "2020-07-23",
  title: "To Be, or Not to Be",
  author: "Christian Battaglia",
  description: "A short autobiography from birth at Johns Hopkins through Maryland, Georgia, Georgia Tech, Barcelona, and landing in New York City — a timeline of the places and moments that made me.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  
  date: "2020-07-23T00:00:00.000Z",
  
  readTime: "3 min read",
  tags: ["autobiography","personal history","Maryland","Georgia","Barcelona","NYC","Georgia Tech","timeline"],
};

export const Route = createFileRoute('/blog/posts/2020-07-23')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/2020-07-23',
    image: '/og/blog/2020-07-23.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
